<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>   
    <template v-slot:right_view>
      <SliceProfileList></SliceProfileList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import SliceProfileList from '../../components/nsmfconfig/sliceProfile/SliceProfileList';

export default {
  name: 'SliceProfilePage',
  components: {
    BasicLayout,
    SliceProfileList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('NSMF.nsmfManage')}/${this.$t('NSMF.sliceProfile')}`
      }
    };
  }
};
</script>